import { MUSIMAP_DIVISIONS, MUSIMAP_FILTERS, MUSIMAP_PROPS, MUSIMAP_WIDGETS } from './musimap-common.enum';
import { IMusimapPreferencesQuery } from './musimap-common.interface';

export const getPreferencesQueryTemplate = (): IMusimapPreferencesQuery => ({
  [MUSIMAP_PROPS.MUSIMAP_PREFERENCES_MARKER]: true,
  [MUSIMAP_PROPS.SEARCH_FILTER_SETTINGS]: {
    filters: [],
  },
});

export const getDefaultPreferences = (): any => {
  const preferencesQuery = getPreferencesQueryTemplate();
  return {
    ...preferencesQuery,
    [MUSIMAP_PROPS.SEARCH_FILTER_SETTINGS]: JSON.stringify(preferencesQuery[MUSIMAP_PROPS.SEARCH_FILTER_SETTINGS]),
  };
};

export const getDefaultDivisionsList = (): any => [
  MUSIMAP_DIVISIONS.WMG,
  MUSIMAP_DIVISIONS.NON_WMG,
  MUSIMAP_DIVISIONS.WCM,
  MUSIMAP_DIVISIONS.NON_WCM,
];
export const getExtendedDivisionsListWithMLR = (): any => [
  MUSIMAP_DIVISIONS.WMG,
  MUSIMAP_DIVISIONS.NON_WMG,
  MUSIMAP_DIVISIONS.THIRD_PARTY_OWNED,
  MUSIMAP_DIVISIONS.WCM,
  MUSIMAP_DIVISIONS.NON_WCM,
  MUSIMAP_DIVISIONS.MLR,
];

export const getExtendedDivisionsList = (): any => [
  MUSIMAP_DIVISIONS.WMG,
  MUSIMAP_DIVISIONS.NON_WMG,
  MUSIMAP_DIVISIONS.THIRD_PARTY_OWNED,
  MUSIMAP_DIVISIONS.WCM,
  MUSIMAP_DIVISIONS.NON_WCM,
];

export const getDefaultDivisionSelections = (): any => ({
  [MUSIMAP_DIVISIONS.WCM]: [MUSIMAP_DIVISIONS.WMG, MUSIMAP_DIVISIONS.NON_WMG, MUSIMAP_DIVISIONS.WCM],
  [MUSIMAP_DIVISIONS.WCM_MLR]: [MUSIMAP_DIVISIONS.WMG, MUSIMAP_DIVISIONS.NON_WMG, MUSIMAP_DIVISIONS.WCM],
  [MUSIMAP_DIVISIONS.WMG]: [MUSIMAP_DIVISIONS.WCM, MUSIMAP_DIVISIONS.NON_WCM, MUSIMAP_DIVISIONS.WMG],
  [MUSIMAP_DIVISIONS.WMG_MLR]: [MUSIMAP_DIVISIONS.WCM, MUSIMAP_DIVISIONS.NON_WCM, MUSIMAP_DIVISIONS.WMG],
  [MUSIMAP_DIVISIONS.WMG_WCM]: getDefaultDivisionsList(),
  [MUSIMAP_DIVISIONS.ALL]: [...getDefaultDivisionsList(), MUSIMAP_DIVISIONS.MLR],
  [MUSIMAP_DIVISIONS.WMG_WCM_MLR]: [...getDefaultDivisionsList(), MUSIMAP_DIVISIONS.MLR],
  [MUSIMAP_DIVISIONS.MLR]: [MUSIMAP_DIVISIONS.MLR],
  [MUSIMAP_DIVISIONS.CLA]: [MUSIMAP_DIVISIONS.WCM, MUSIMAP_DIVISIONS.NON_WCM, MUSIMAP_DIVISIONS.WMG],
  [MUSIMAP_DIVISIONS.WMG_WCM_CLA]: getDefaultDivisionsList(),
  [MUSIMAP_DIVISIONS.WMG_CLA]: [MUSIMAP_DIVISIONS.WCM, MUSIMAP_DIVISIONS.NON_WCM, MUSIMAP_DIVISIONS.WMG],
});

export const getExtendedDivisionSelections = (): any => {
  const wmgList = [
    MUSIMAP_DIVISIONS.WCM,
    MUSIMAP_DIVISIONS.NON_WCM,
    MUSIMAP_DIVISIONS.WMG,
    MUSIMAP_DIVISIONS.THIRD_PARTY_OWNED,
  ];
  const wcmList = [
    MUSIMAP_DIVISIONS.WMG,
    MUSIMAP_DIVISIONS.NON_WMG,
    MUSIMAP_DIVISIONS.WCM,
    MUSIMAP_DIVISIONS.THIRD_PARTY_OWNED,
  ];

  return {
    [MUSIMAP_DIVISIONS.WCM]: wcmList,
    [MUSIMAP_DIVISIONS.WCM_MLR]: wcmList,
    [MUSIMAP_DIVISIONS.WMG]: wmgList,
    [MUSIMAP_DIVISIONS.WMG_MLR]: wmgList,
    [MUSIMAP_DIVISIONS.WMG_WCM]: getExtendedDivisionsList(),
    [MUSIMAP_DIVISIONS.ALL]: getExtendedDivisionsListWithMLR(),
    [MUSIMAP_DIVISIONS.WMG_WCM_MLR]: getExtendedDivisionsListWithMLR(),
    [MUSIMAP_DIVISIONS.MLR]: [MUSIMAP_DIVISIONS.MLR],
    [MUSIMAP_DIVISIONS.CLA]: wmgList,
    [MUSIMAP_DIVISIONS.WMG_CLA]: wmgList,
    [MUSIMAP_DIVISIONS.WMG_WCM_CLA]: getExtendedDivisionsList(),
  };
};

export const getDefaultFiltersSettings = (): any => ({
  [MUSIMAP_FILTERS.GENRES]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.MOOD]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.CHART_DATES]: {
    type: MUSIMAP_WIDGETS.CHART_SELECTOR,
  },
  [MUSIMAP_FILTERS.THEME]: {
    label: 'Lyric Theme',
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.SCENE]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.VOCALS]: {
    type: MUSIMAP_WIDGETS.MULTI_SOURCE_TAGS_SELECTOR,
    sources: [MUSIMAP_FILTERS.VOCALS],
    useDefaultOperator: true,
  },
  [MUSIMAP_FILTERS.LANGUAGE]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.ROC]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.KEY]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.RHYTHMIC_VIBE]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.VERSION]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.RECORD_LABEL]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.ASSET_TYPE]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.CHART_RANGE]: {
    type: MUSIMAP_WIDGETS.CHART_RANGE_SELECTOR,
  },
  [MUSIMAP_FILTERS.BPM]: {
    type: MUSIMAP_WIDGETS.RANGE_SELECTOR,
  },
  [MUSIMAP_FILTERS.DURATION]: {
    type: MUSIMAP_WIDGETS.RANGE_SELECTOR,
  },
  [MUSIMAP_FILTERS.DIVISIONS]: {
    type: MUSIMAP_WIDGETS.DIVISIONS_SELECTOR,
  },
  [MUSIMAP_FILTERS.PUBLISHING_CONTROL]: {
    type: MUSIMAP_WIDGETS.OPTIONS_SELECTOR,
  },
  [MUSIMAP_FILTERS.RELEASE_YEAR]: {
    type: MUSIMAP_WIDGETS.RANGE_SELECTOR,
  },
  [MUSIMAP_FILTERS.COPYRIGHT_YEAR]: {
    type: MUSIMAP_WIDGETS.RANGE_SELECTOR,
  },
  [MUSIMAP_FILTERS.GCDM_VERSION]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.RATING]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TAGS_SELECTOR,
  },
  [MUSIMAP_FILTERS.PROFIT_CENTER]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.ARTIST]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.TITLE]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.LABEL]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.ISRC]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.WRITER]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.ALBUM]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.ORIGINAL_ALBUM]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
  [MUSIMAP_FILTERS.LYRICS]: {
    type: MUSIMAP_WIDGETS.SIMPLE_TEXT_SELECTOR,
  },
});
